// Region is a string identifier for a regional service instance (e.g. "us", "eu").
// New regions are added at runtime via configuration, so this type is intentionally open.
export type Region = string;

export const US_REGION: Region = "us";
export const EU_REGION: Region = "eu";
